/** @jsxImportSource theme-ui */
import { Container, Heading, Flex, Box, Card } from 'theme-ui';
import { useParams, useNavigate } from 'react-router-dom';
import DiscountAgreements from '@/containers/dicountAgreements/DiscountAgreements';
import Button from '@/components/Button';
import { useDeleteDiscountAgreementsMutation } from '@/store/apiService';
import FilterAgreements from '@/containers/dicountAgreements/FilterDiscountAgreements';
import PublishDiscountAgreementButton from '@/containers/dicountAgreements/PublishDiscountAgreementButton';

const DiscountAgreementPage = () => {
    const { companyId } = useParams<{ companyId: string }>();
    const navigate = useNavigate();

    return (
        <Container>

            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Flex sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => {
                            navigate('/voss/discount-agreements/new');
                        }}
                    >
                        Create discount agreement
                    </Button>
                </Flex>

                <Card variant="widget" sx={{ position: 'relative', zIndex: 100 }}>
                    <Heading as="h2">Filter agreements</Heading>
                    <FilterAgreements />
                </Card>

                <DiscountAgreements
                    actions={{
                        accessor: 'Actions',
                        Cell: ({ cell, row }) => {
                            const agreementId = row.original.Id;
                            const isDraft = row.original.Status === 'Draft';
                            const [deleteAgreement, deleteAgreementState] =
                                useDeleteDiscountAgreementsMutation();

                            return (
                                <Flex
                                    sx={{
                                        justifyContent: 'center',
                                        gap: 2,
                                        alignItems: 'center',
                                    }}
                                >
                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            navigate(`/voss/discount-agreements/${agreementId}`);
                                        }}
                                    >
                                        Edit
                                    </Button>
                                    {isDraft ? (
                                        <PublishDiscountAgreementButton agreementId={agreementId} />
                                    ) : null}
                                    <Button
                                        isLoading={deleteAgreementState.isLoading}
                                        variant="danger"
                                        onClick={() => {
                                            deleteAgreement(agreementId);
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </Flex>
                            );
                        },
                    }}
                />
            </Flex>
        </Container>
    );
};

export default DiscountAgreementPage;
